/* eslint-disable */
// eslint-disable-next-line
import Vue from 'vue'
import store from '@/store/index'
import router from '@/router'

class OcGoogleAnalitycs {
  parentLocation:any = {}

  constructor () {
    this.parentLocation = store.state.parentLocation
  }

  dataLayerPush (data:any) {
    const googleAnalitycsConfig = Vue.prototype.$organization.googleAnalitycs()

    if (!googleAnalitycsConfig.isActive) {
      return false
    }

    const configData = googleAnalitycsConfig.data

    if (configData) {
      let journey_type_obj = data.hasOwnProperty('journey_type') ? data.journey_type : ''
      data = Object.assign(data, configData)
      
      if (journey_type_obj) {
        data.journey_type = journey_type_obj
      }
    }

    for (let index = 0; index < Object.keys(data).length; index++) {
      const key = Object.keys(data)[index]

      if (data[key] === '[current_time]') {
        data[key] = new Date()
      } else if (data[key] === '[origin]') {
        data[key] = this.parentLocation.origin
      }
    }

    window.parent.postMessage(`ocGoogleAnalitycs.dataLayerPush(${JSON.stringify(data)})`, '*')
  }

  getDataLayerConfig(code: string, routeName = true) {
    const actionCode = routeName ? `${(router as any).history.current.name}-${code}` : code
    // console.log('ActionCode =========>>> ', actionCode)
    const { dataLayerConfig } = Vue.prototype.$organization.googleAnalitycs()

    if (!dataLayerConfig) {
      return false
    } 

    const config = dataLayerConfig.find((config: any) => config.action_code === actionCode)

    if (!config) {
      return false
    }
    const dataLayer = this.datalayerDecode(JSON.parse(config.data_layer), store)
    // console.log('dataLayer ==========>>> ', dataLayer)
    this.dataLayerPush(dataLayer)
  }

  private datalayerDecode (data: any, obj: any) {
    const dataLayer: any = {}
    
    for (const [key, value] of Object.entries(data)) {
      if (typeof value === 'object') {
        dataLayer[key] = this.getDescendantProp(obj, (value as any).ref)

        if ((value as any).isCode && dataLayer[key]) {
          dataLayer[key] = btoa(dataLayer[key])
        }

        if ((value as any).isBooleanCase) {
          const { trueCase, falseCase } = (value as any).isBooleanCase
          dataLayer[key] = dataLayer[key] ? trueCase : falseCase
        }
      } else {
        dataLayer[key] = value
      }
    }

    return dataLayer
  }

  private getDescendantProp(obj: any, desc: any) {
    const arr = desc.split('.')
    return arr.reduce((acc: any, val:any) => acc && acc[val], obj)
    // while(arr.length) {
    //   obj = obj[arr.shift()]
    //   if (!obj) {
    //     break
    //   }
    // }
    // return obj
  }
}

export default new OcGoogleAnalitycs()
